import clsx from "clsx";

export type SafetyStripProps = {
  note: string;
  /** The domain's blanket caution, when it differs from the entry's own note. */
  domainNote?: string | null;
  className?: string;
};

/**
 * A caution strip in rust, with hazard hatching down the left edge. This is the
 * one element in Foundling allowed to be loud: on a fungus page it must be
 * impossible to miss, and it is never collapsed or truncated.
 */
export function SafetyStrip({ note, domainNote, className }: SafetyStripProps) {
  const showDomainNote =
    typeof domainNote === "string" &&
    domainNote.trim().length > 0 &&
    domainNote.trim() !== note.trim();

  return (
    <aside
      role="note"
      aria-label="Safety note"
      className={clsx(
        "relative flex overflow-hidden rounded-[2px] border-2 border-rust bg-[color-mix(in_oklab,var(--color-rust)_8%,var(--color-card))]",
        className,
      )}
    >
      <span
        aria-hidden="true"
        className="w-3 shrink-0 bg-[repeating-linear-gradient(45deg,var(--color-rust)_0_6px,transparent_6px_12px)]"
      />
      <div className="min-w-0 flex-1 px-3 py-2.5">
        <p className="field-label text-rust">Take care</p>
        <p className="mt-1 font-prose text-[0.95rem] leading-snug text-ink">{note}</p>
        {showDomainNote ? (
          <p className="mt-1.5 font-prose text-sm leading-snug text-ink-soft">{domainNote}</p>
        ) : null}
      </div>
    </aside>
  );
}
